import { render, staticRenderFns } from "./Munit.vue?vue&type=template&id=20cbd572&"
import script from "./Munit.vue?vue&type=script&lang=js&"
export * from "./Munit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports